export default "__VITE_ASSET__08580e6d__"